/**
 * Restricted Collection Access Script
 * 
 * This script checks if the user has authentication to view a restricted collection.
 * If the user is not authenticated, they are redirected to the landing page.
 */

(function() {
  const RESTRICTED_COLLECTIONS = [];

  const LANDING_PAGE = '/pages/restricted-access-summer26';

  function getAuth(slug) {
    var raw = localStorage.getItem(slug + ':auth');
    if (!raw) return null;
    try {
      var entry = JSON.parse(raw);
      if (entry.expiry && Date.now() > entry.expiry) {
        localStorage.removeItem(slug + ':auth');
        return null;
      }
      return entry.value;
    } catch (e) {
      localStorage.removeItem(slug + ':auth');
      return null;
    }
  }

  function init() {
    var currentPath = window.location.pathname.toLowerCase();
    var matched = RESTRICTED_COLLECTIONS.find(function(c) {
      return currentPath === c || currentPath === c + '/' || currentPath.startsWith(c + '?');
    });
    if (!matched) return;

    var slug = matched.replace('/collections/', '');
    var authData = getAuth(slug);
    var isValid = authData && authData.authenticated &&
      (currentPath.startsWith(authData.collection) || currentPath === authData.collection);

    if (!isValid) {
      window.location.href = LANDING_PAGE;
    }
  }

  document.addEventListener('DOMContentLoaded', init);
})();